
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LandingPage from '../../pages/LandingPage';

const IntelligentHomeRoute = () => {
  const { user, loading } = useAuth();
  
  // Add debugging for intelligent routing
  console.log('IntelligentHomeRoute - user:', user?.id, 'loading:', loading);
  console.log('IntelligentHomeRoute - current hostname:', window.location.hostname);
  console.log('IntelligentHomeRoute - current href:', window.location.href);
  
  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-uplivion-lightBlue bg-opacity-20">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-uplivion-blue mx-auto mb-4"></div>
          <p className="text-uplivion-blue">Lädt...</p>
        </div>
      </div>
    );
  }
  
  if (user) {
    console.log('IntelligentHomeRoute - User authenticated, redirecting to app.uplivion.life/dashboard');
    // Redirect authenticated users to app domain
    window.location.href = 'https://app.uplivion.life/dashboard';
    return null;
  }
  
  console.log('IntelligentHomeRoute - No user, showing landing page directly');
  // Show landing page directly for non-authenticated users
  return <LandingPage />;
};

export default IntelligentHomeRoute;
